function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import Portal from "../Portal/Portal";
import "./Modal.css";
const bodyOpenClassName = "ax-modal__body--open";

const enableScrolling = () => {
  document.body.classList.remove(bodyOpenClassName);
};

const disableScrolling = () => {
  document.body.classList.add(bodyOpenClassName);
};

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
  }

  componentDidMount() {
    if (this.props.isOpen) {
      disableScrolling();
    }

    if (this.props.shouldCloseOnEsc) {
      document.body.addEventListener("keydown", this.handleEscapeKey, false);
    }
  }

  componentWillUnmount() {
    enableScrolling();

    if (this.props.shouldCloseOnEsc) {
      document.body.removeEventListener("keydown", this.handleEscapeKey, false);
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      disableScrolling();
    } else if (prevProps.isOpen && !this.props.isOpen) {
      enableScrolling();
    }

    if (this.props.shouldCloseOnEsc !== prevProps.shouldCloseOnEsc) {
      this.toggleEscapeEventListener();
    }
  }

  toggleEscapeEventListener() {
    if (this.props.shouldCloseOnEsc) {
      document.body.addEventListener("keydown", this.handleEscapeKey, false);
    } else {
      document.body.removeEventListener("keydown", this.handleEscapeKey, false);
    }
  }

  handleEscapeKey(event) {
    const {
      onOverlayClick,
      shouldCloseOnEsc
    } = this.props;

    if (event.key === "Escape" && shouldCloseOnEsc) {
      if (onOverlayClick) {
        onOverlayClick();
      }
    }
  }

  render() {
    const {
      children,
      isOpen,
      overlayShade,
      overlayTheme,
      onOverlayClick,
      padding,
      role,
      "aria-labelledby": labelledBy,
      "aria-describedby": describedBy,
      "aria-label": label
    } = this.props;
    const classes = classnames("ax-modal__container", `ax-modal__container--padding-${padding}`, {
      [`ax-modal__container--overlay-${overlayShade}`]: overlayShade
    });
    return isOpen ? /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Base, {
      className: classes,
      theme: overlayTheme,
      role: role,
      "aria-modal": "true",
      "aria-labelledby": labelledBy,
      "aria-describedby": describedBy,
      "aria-label": label
    }, onOverlayClick && /*#__PURE__*/React.createElement("div", {
      className: "ax-modal__mask",
      onClick: onOverlayClick
    }), /*#__PURE__*/React.createElement("div", {
      className: "ax-modal"
    }, children))) : null;
  }

}

_defineProperty(Modal, "defaultProps", {
  overlayShade: "shade-2",
  padding: "x6",
  role: "dialog"
});